<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link>|
      <router-link to="/about">About</router-link>
    </div>
    <router-view />-->
    <!-- <div class="particles">
      <vue-particles
        color="#d3d3d3"
        :particleOpacity="0.7"
        :particlesNumber="80"
        shapeType="star"
        :particleSize="4"
        linesColor="#d3d3d3"
        :linesWidth="1"
        :lineLinked="true"
        :lineOpacity="0.4"
        :linesDistance="150"
        :moveSpeed="6"
        :hoverEffect="true"
        hoverMode="grab"
        :clickEffect="true"
        clickMode="push"
      ></vue-particles>
    </div> -->
    <sjpHead v-if="path !=='/logreg'"></sjpHead>
    <sjpNav v-if="path !=='/logreg'"></sjpNav>
    <router-view />
    <!-- <sjpFoot></sjpFoot> -->
    <sjpFoot v-if="path !=='/logreg'"></sjpFoot>
    <!-- 
color: String类型。默认'#dedede'。粒子颜色。
particleOpacity: Number类型。默认0.7。粒子透明度。
particlesNumber: Number类型。默认80。粒子数量。
shapeType: String类型。默认'circle'。可用的粒子外观类型有："circle","edge","triangle", "polygon","star"。
particleSize: Number类型。默认80。单个粒子大小。
linesColor: String类型。默认'#dedede'。线条颜色。
linesWidth: Number类型。默认1。线条宽度。
lineLinked: 布尔类型。默认true。连接线是否可用。
lineOpacity: Number类型。默认0.4。线条透明度。
linesDistance: Number类型。默认150。线条距离。
moveSpeed: Number类型。默认3。粒子运动速度。
hoverEffect: 布尔类型。默认true。是否有hover特效。
hoverMode: String类型。默认true。可用的hover模式有: "grab", "repulse", "bubble"。
clickEffect: 布尔类型。默认true。是否有click特效。
clickMode: String类型。默认true。可用的click模式有: "push", "remove", "repulse", "bubble"
    -->
  </div>
</template>

<script>
import sjpHead from "./public/header";
import sjpNav from "./public/nav";
import sjpFoot from "./public/footer";
export default {
  name: "App",
  data() {
    return {
      path: ""
    };
  },
  components: {
    sjpHead,
    sjpNav,
    sjpFoot
  },
  created() {},
  methods: {},
  mounted() {},
  watch: {
    $route(to, from) {
      console.log(to, from);
      this.path = to.path;
    }
  }
};
</script>

<style lang="less">
#app {
  // font-family: "Avenir", Helvetica, Arial, sans-serif;
  // -webkit-font-smoothing: antialiased;
  // -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  // color: #2c3e50;
}

// #nav {
//   padding: 30px;
//   a {
//     font-weight: bold;
//     color: #2c3e50;

//     &.router-link-exact-active {
//       color: #42b983;
//     }
//   }
// }
</style>
